/**
 * sidebarのレンダリング時に使う時間のフォーマットのモジュール
 */
import moment from 'moment';

export function getPeriodStartTime (start) {
  const startTime = new Date(start);
  return {
    startDate: `${startTime.getMonth() + 1}月${startTime.getDate()}日`,
    startDay: `(${['日', '月', '火', '水', '木', '金', '土'][startTime.getDay()]})`,
    startTime: `${startTime.getHours().toString().padStart(2, '0')}:${startTime.getMinutes().toString().padStart(2, '0')}`
  };
}

export function getPeriodEndTime (end) {
  const endTime = new Date(end);
  return `${endTime.getHours().toString().padStart(2, '0')}:${endTime.getMinutes().toString().padStart(2, '0')}`;
}

export function toHms (t) {
  if ((t / 3600 | 0) === 0) {
    return `${(t % 3600 / 60 | 0).toString().padStart(2, '0')}:${(t % 60).toString().padStart(2, '0')}`;
  } else {
    return `${(t / 3600 | 0).toString().padStart(2, '0')}:${(t % 3600 / 60 | 0).toString().padStart(2, '0')}:${(t % 60).toString().padStart(2, '0')}`;
  }
}

export function tvCreatedAtStr (str) {
  return moment(new Date(str)).format('YYYY年MM月DD日 HH時mm分');
}
